import {Injectable} from '@angular/core';
import {
  InAppNotificationLogsQuery,
  MarkReadAllInAppNotificationLogMutation,
  ReadInAppNotificationLogMutation,
} from '@generated/graphql';
import {map, Observable} from 'rxjs';
import {
  inAppNotificationLogModelFactory
} from "@modules/in-app-notification-log/factories/in-app-notification-log.factory";
import {InAppNotificationLog} from "@modules/in-app-notification-log/models/in-app-notification-log.model";
import {paginationDataFactory} from "@shared/factories/pagination.factory";
import {PaginationData} from "@shared/types/pagination.type";

@Injectable({
  providedIn: 'root',
})
export default class InAppNotificationLogApi {
  public constructor(
    private readonly inAppNotificationLogsQuery: InAppNotificationLogsQuery,
    private readonly readInAppNotificationLogMutation: ReadInAppNotificationLogMutation,
    private readonly markReadAllInAppNotificationLogMutation: MarkReadAllInAppNotificationLogMutation,
  ) {
  }

  public get$(): Observable<{
    paginator: PaginationData<InAppNotificationLog>,
    unreadCount: number
  }> {
    return this.inAppNotificationLogsQuery.fetch({}, {fetchPolicy: 'no-cache'}).pipe(
      map(response => ({
        paginator: paginationDataFactory.create(response.data.inAppNotificationLogs.paginator, inAppNotificationLogModelFactory),
        unreadCount: response.data.inAppNotificationLogs.unreadCount
      })),
    );
  }

  public read$(logId: string): Observable<boolean> {
    return this.readInAppNotificationLogMutation.mutate({
      logId,
    }).pipe(map((response) => response.data.readInAppNotificationLog));
  }

  public markReadAll$(): Observable<boolean> {
    return this.markReadAllInAppNotificationLogMutation
      .mutate()
      .pipe(map((response) => response.data.markReadAllInAppNotificationLog));
  }
}
